import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
import styled, {css} from 'styled-components';

import {MOBILE_WIDTH} from '../util/gallery';

const SPACING = 32;
const MOBILE_SPACING = 16;

type PostWrapperStylesProps = {
  onClick?: () => void;
};
const postWrapperStyles = css<PostWrapperStylesProps>`
  display: block;
  padding: ${SPACING / 2}px;
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  ${props => props.onClick != null && `cursor: pointer;`}

  &:hover {
    transform: scale(1.005);
    box-shadow: 1px 1px 14px rgb(0 0 0 / 8%);
  }

  @media (max-width: ${MOBILE_WIDTH}px) {
    padding: ${MOBILE_SPACING * 1.5}px 0 0 8px;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;
export const PostWrapper = styled.div<PostWrapperStylesProps>`
  ${postWrapperStyles}
`;
export const PostWrapperLink = styled(Link)<PostWrapperStylesProps>`
  ${postWrapperStyles}
`;

export const Post = styled.div`
  position: relative;
  padding-right: 132px;

  @media (max-width: ${MOBILE_WIDTH}px) {
    padding-right: 96px;
  }
`;

export const PostTitle = styled.div`
  color: ${globals.THEME.textPrimary};
  font-size: 20px;
  font-weight: 600;

  @media (max-width: ${MOBILE_WIDTH}px) {
    font-size: 17px;
  }
`;

export const postFlairStyles = css<{color?: string}>`
  &&&&& {
    color: ${props => (props.color ? 'white' : globals.THEME.textPrimary)};
    font-size: 14px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 12px;
    background-color: ${props => props.color || globals.THEME.bgSurfaceSunken};
    margin-right: 8px;
    vertical-align: top;

    @media (max-width: ${MOBILE_WIDTH}px) {
      font-size: 12px;
      position: relative;
      top: 1px;
    }
  }
`;
export const PostFlair = styled.span`
  ${postFlairStyles}
`;
export const PostFlairLink = styled(Link)`
  ${postFlairStyles}
`;

export const PostMeta = styled.div`
  color: ${globals.THEME.textTertiary};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 6px;

  a {
    color: ${globals.THEME.textTertiary};

    &:hover {
      color: ${globals.THEME.textPrimary};
    }
  }

  @media (max-width: ${MOBILE_WIDTH}px) {
    font-size: 15px;
  }
`;

export const DotSeparator = styled.div`
  border-radius: 50%;
  width: 2px;
  height: 2px;
  margin: 12px 8px 0 8px;
  background-color: ${globals.THEME.textTertiary};
  display: inline-block;
  vertical-align: top;
`;

export const PostImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 80px;
  object-fit: cover;
  border-radius: 4px;
`;
